<template>
  <section id="talk">
    <base-card>
      <v-card-title
        :class="[$vuetify.breakpoint.mdAndUp ? 'display-2' : 'display-1']"
        class="justify-center font-weight-bold grey--text text--darken-3 mb-3 text-center mx-auto"
      >
        Cloud Engineer <br>
        Web Developer <br>
        Power Platform Expert
      </v-card-title>
      <v-card-text class="text-left text-md-center text-h6 font-weight-light mx-auto mb-5">
        A Cloud Engineer by trade, my expertise is in the Microsoft stack, including but not limited to, Azure, Office 365, Graph API, Azure Static Web Apps, Power BI, Power Platform, and Dynamics 365
      </v-card-text>

      <v-container>
        <v-row>
          <v-col
            v-for="(feature, i) in features"
            :key="i"
            cols="12"
            md="4"
            sm="6"
          >
            <div class="text-center">
              <v-icon
                :color="feature.color"
                :size="64"
                class="mb-3"
                v-text="feature.icon"
              />
              <p
                class="text-justify text-md-center"
                v-text="feature.text"
              />
            </div>
          </v-col>
        </v-row>
      </v-container>

      <v-divider class="my-5 mx-3" />

      <v-card-title
        :class="[$vuetify.breakpoint.mdAndUp ? 'display-2' : 'display-1']"
        class="justify-center font-weight-bold grey--text text--darken-3 mb-3 text-center mx-auto"
      >
        Certifications
      </v-card-title>
      <v-card-text class="text-left text-md-center text-h6 font-weight-light mx-auto mb-5">
        MB-210 - Microsoft Dynamics 365 Sales Functional Consultant <br><br>
        MB-230 - Microsoft Dynamics 365 Customer Service Functional Consultant <br><br>
        PL-600 - Microsoft Power Platform Solution Architect <br><br>
        PL-400 - Microsoft Power Platform Developer <br><br>
        PL-200 - Microsoft Power Platform Functional Consultant <br><br>
        PL-100 - Microsoft Power Platform App Maker <br><br>
        SC-200 - Microsoft Security Operations Analyst <br><br>
        PL-900 - Microsoft Power Platform Fundamentals <br><br>
        MS-500 - Microsoft 365 Security Administration <br><br>
        MS-700 - Managing Microsoft Teams <br><br>
        MS-900 - Microsoft 365 Fundamentals
      </v-card-text>
    </base-card>
  </section>
</template>

<script>
  export default {
    name: 'HomeContents',

    data: () => ({
      features: [
        {
          icon: 'mdi-forklift',
          color: 'indigo',
          text: 'My background is in IT - most of my career has been spent in the service industry, and IT has always been my first love',
        },
        {
          icon: 'mdi-nodejs',
          color: 'green',
          text: 'Adding development skills has elevated my IT career. I pride myself on bridging the sometimes-hostile gap between IT and development',
        },
        {
          icon: 'mdi-widgets',
          color: 'primary',
          text: 'The Power Platform has been a crucial piece of technology while working in the MSP industry and expanding the offerings of the typical IT services industry',
        },
      ],
    }),
  }
</script>
